import { post } from '../index';

export const updateIfcProject = data => {
  console.log(data);
  return post('/ifcProject/update', data, true);
};
